// components
import Slider from 'react-slick';
import { ReactSVG } from 'react-svg';
import { i18n as I18n, useTranslation } from '../../../utils/i18n';

const NextBtn = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button className="right-arrow">
      <ReactSVG
        src="../../../images/icons/homepage/testimonials/right-arrow.svg"
        onClick={onClick}
      />
    </button>
  );
};

const PrevBtn = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button className="left-arrow">
      <ReactSVG
        src="../../../images/icons/homepage/testimonials/left-arrow.svg"
        onClick={onClick}
      />
    </button>
  );
};

const TextSlideShow = ({
  slidesArray,
}: {
  slidesArray: Array<{ quote: string; by: string }>;
}) => {
  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    duration: 1000,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 6000,
    nextArrow: <NextBtn />,
    prevArrow: <PrevBtn />,
  };

  const { t } = useTranslation('common');

  const slides = slidesArray.map((text, index) => (
    <div className="text-slide" key={index}>
      <div className="text-wrap">
        <h2>{t(text.quote)}</h2>
        <p>{t(text.by)}</p>
      </div>
    </div>
  ));

  return <Slider {...settings}>{slides}</Slider>;
};

export default TextSlideShow;
